// Customizable Area Start
import React, { Component } from "react";
import { IconButton, IconButtonProps, styled } from "@mui/material";

type IconTypes = "primary" | "error" | "secondary";

const IconWrapper = styled("button", {
  shouldForwardProp: (prop) => prop !== "customVariant",
})<{ customVariant: IconTypes; disabled: boolean }>(
  ({ customVariant, disabled }) => ({
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    outline: "none",
    border: "none",
    "& svg": {
      height: "20px",
      width: "20px",
      color: "#fff",
    },
    "&:hover": {
      opacity: 0.9,
    },
    ...(customVariant === "primary" && {
      backgroundColor: "#652784",
      "&:hover": {
        backgroundColor: "#541D6A",
      },
    }),
    ...(customVariant === "error" && {
      backgroundColor: "#DC2626",
      "&:hover": {
        backgroundColor: "#B91C1C",
      },
    }),

    ...(customVariant === "secondary" && {
      backgroundColor: "#EFF6FF",
      "&:hover": {
        backgroundColor: "#DBEAFE",
      },
      "& svg": {
        color: "#652784",
      },
    }),
    ".Mui-disabled": {
      opacity: 0.6
    }
  })
);

interface Props extends IconButtonProps {
  customVariant: IconTypes;
  children: React.ReactNode;
}

class CustomIconButton extends Component<Props> {
  render() {
    const { children, ...rest } = this.props;
    return <IconWrapper {...rest}>{children}</IconWrapper>;
  }
}

export default CustomIconButton;
// Customizable Area End
